import React, { useContext } from 'react';
import './FastRecieve.css';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import FirstEn from '../../../assets/images/mainPbl/fastWay/item1.webp'

import SecondEn from '../../../assets/images/mainPbl/fastWay/item2En.webp'
import SecondBg from '../../../assets/images/mainPbl/fastWay/item2Bg.webp'

import FirthdEn from '../../../assets/images/mainPbl/fastWay/item3.webp'

import FourEn from '../../../assets/images/mainPbl/fastWay/item4En.webp'
import FourBg from '../../../assets/images/mainPbl/fastWay/item4Bg.webp'

import useWindowSize from '../../../assets/hooks/useWindowSize';

function FastRecieve({ language }) {
    const { mainPbl } = useContext(TranslationContext);
    const { mainFastRecieve } = mainPbl;
    const { cards } = mainFastRecieve;
    const { width } = useWindowSize()

    const CARDS = [
        {
            en: FirstEn,
            bg: FirstEn,
            title: cards.firstCard.title
        },
        {
            en: SecondEn,
            bg: SecondBg,
            title: cards.secondCard.title
        },
        {
            en: FirthdEn,
            bg: FirthdEn,
            title: cards.firthCard.title
        },
        {
            en: FourEn,
            bg: FourBg,
            title: cards.fourCard.title
        },
    ]

    return (
        <div className='fast-recieve'>
            <button className={`fast-recieve__button head-banner__button_pc`} type='button'>
                {mainFastRecieve.textOnGreen}
            </button>

            <p className='fast-recieve__title'>{mainFastRecieve?.title}</p>
            <p className='fast-recieve__subtitle'>{mainFastRecieve.subtitle}</p>

            <div className='fast-recieve__cards-grid'>
                {CARDS.map((item, i) => {
                    return (
                        <div className='fast-recieve__card'>
                            <img src={language === 'EN' ? item.en : item.bg} alt='' className='fast-recieve__card__img'></img>
                            <p className='fast-recieve__card__text' dangerouslySetInnerHTML={{ __html: item.title }} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default FastRecieve